/** Decorative paw-in-thought-bubble illustration for the Meet Ask Dynamo card. */
export function AskDynamoPawIllustration({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden
    >
      <path
        d="M12 38c0-10 8-18 18-18 4 0 7.5 1.3 10.5 3.5C43.5 21.3 47 20 51 20c10 0 18 8 18 18 0 2-.3 3.9-.9 5.7-2.8 8.5-10.5 14.3-19.1 14.3H32c-8.6 0-16.3-5.8-19.1-14.3-.6-1.8-.9-3.7-.9-5.7z"
        fill="var(--color-ask-dynamo-surface)"
        stroke="var(--color-ask-dynamo)"
        strokeWidth="2"
      />
      <ellipse cx="28" cy="36" rx="4" ry="5" fill="var(--color-ask-dynamo)" opacity="0.85" />
      <ellipse cx="40" cy="32" rx="4" ry="5" fill="var(--color-ask-dynamo)" opacity="0.85" />
      <ellipse cx="52" cy="36" rx="4" ry="5" fill="var(--color-ask-dynamo)" opacity="0.85" />
      <ellipse cx="34" cy="44" rx="3.5" ry="4" fill="var(--color-ask-dynamo)" opacity="0.7" />
      <ellipse cx="46" cy="44" rx="3.5" ry="4" fill="var(--color-ask-dynamo)" opacity="0.7" />
      <circle cx="62" cy="18" r="2" fill="var(--color-ask-dynamo)" opacity="0.6" />
      <circle cx="68" cy="26" r="1.5" fill="var(--color-ask-dynamo)" opacity="0.5" />
      <path
        d="M8 20c-2-4 0-8 4-8s5 3 4 7"
        stroke="var(--color-ask-dynamo)"
        strokeWidth="2"
        strokeLinecap="round"
        opacity="0.5"
      />
    </svg>
  )
}
